var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 132,
    viewBox: "0 0 133 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0202 14.1243C23.9555 26.9282 19.8936 38.2079 19.8936 44.7268V100.16H64.5219V0C56.26 3.9602 48.3912 8.68925 41.0202 14.1243Z",
    fill: "#F4DB49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4932 14.592V100.16H106.458V52.8151C106.458 47.2544 103.008 37.6194 88.4776 26.6792C82.2142 22.0332 75.5227 17.9911 68.4932 14.6071",
    fill: "#F4DB49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 103.48C133 114.865 124.158 125.074 110.149 132H22.8512C8.84246 125.074 0 114.865 0 103.48H133Z",
    fill: "#F4DB49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 132,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcon);
export default __webpack_public_path__ + "static/media/header-icon.1ed00e0d8a88779f4920928b944a7fe0.svg";
export { ForwardRef as ReactComponent };